import axios from 'axios';
import { BadgesAPI } from '../shared/constants';
import {_createWarrantyRequest, _createVehiclesUserRequest} from '../shared/http-request-util'
import REQUEST from '../shared/http-request-util';
/**
 *
 * @param {*} headers
 */
function _createRequest() {
  let userData = JSON.parse(localStorage.getItem('user-data'));
  return axios.create({
    baseURL: BadgesAPI.FIND,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "countryCode": 'BR',
      'id_token': userData.token,
      'Authorization': `Bearer ${userData.token}`,
      'transactionID': userData.email,
      'timeout': 5000
    },
  });
}

export const getWarrantySeal = async (chassis, email) => {
  try {
    console.log("BADGES")
    const result = await REQUEST()._createWarrantyRequest().get(`/${chassis}`)
    if (result && result.data) {
      return result.data;
    }
    return null;
  } catch (error) {
     console.log(JSON.stringify(error))
  return null;
  }
}


export const getVehiclesUser = async (token, email) => {

  try {
    const result = await REQUEST()._createVehiclesUserRequest().get(`/${email}`)
    if (result && result.data) {
      return result.data;
    }
    return null;
  } catch (error) {
     console.log(error)
  return null;
  }
}

export const getModelData = async (selectedCar) => {
  try {
    const result = await _createRequest().post('/', selectedCar)
    console.log('Result model', result);
    if (result && result.data) {
      return result.data;
    }
    return null;
  } catch (error) {
    console.log('Error user garage:', error.response);
    // window.location.href = `${basePath()}/error`
    return null;
  }
};


export const filterCarData = (list, vin) => {
  let selectedModel = list.find(filtered => filtered.vin === vin)
  if(!selectedModel) return null

  return {
    "userVehicle": {
      "chassis": selectedModel.vin,
      "mileage": selectedModel.mileage,
      "dateLicense": selectedModel.purchaseDate,
      // "dateLicense": selectedModel.dateLicense,
      "modelCode": selectedModel.modelCode,
      "modelYear": selectedModel.modelYear
    }
  }
}
